﻿import { queries } from "@/graphql";
import { useQuery } from "@apollo/client/react";
export function useGetPublicToken() {
  const { data, loading } = useQuery<any>(queries.getPublicToken, {
    errorPolicy: "all",
  });

  return {
    token: data?.getPublicToken?.token,
    loading,
  };
}
